import { render, staticRenderFns } from "./CareProfileForm.vue?vue&type=template&id=7da0225c&"
import script from "./CareProfileForm.vue?vue&type=script&lang=js&"
export * from "./CareProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports